import create from "./create";
import db, { getVersions } from "pack-db";
import pathToRegexp from "path-to-regexp";

const GAME_API_ROOT =
  process.env.GATSBY_API_URL ||
  "https://pnkqmt3fc2.execute-api.us-east-1.amazonaws.com/production/api";

const api = create();
export const gameApi = create({ baseUrl: GAME_API_ROOT });

const originalGet = api.get;

function parseFilters(string) {
  const filters = string.split("AND");

  return filters.reduce((accumulator, filter) => {
    const [key, value] = filter.split("=");
    const [includeKey, includeValue] = filter.split("_in_");

    if (includeValue) {
      accumulator[includeKey] = includeValue.split(",");
      return accumulator;
    }

    if (!value) {
      return accumulator;
    }

    accumulator[key] = value;
    return accumulator;
  }, {});
}

const PATTERNS = {
  "v1alpha1/packs": function (_, query) {
    const filters = parseFilters(query.filters);

    return {
      items: db.collection("packs").filter((item) => {
        const matchesCloudType = filters["spec.cloudTypes"].every(
          (cloudType) => {
            if (cloudType === "all") {
              return true;
            }
            return item.spec.cloudTypes.includes(cloudType);
          },
        );
        let isCandidate =
          item.spec.layer === filters["spec.layer"] && matchesCloudType;
        if (filters["spec.addonType"]) {
          return (
            isCandidate && item.spec.addonType === filters["spec.addonType"]
          );
        }
        return isCandidate;
      }),
    };
  },

  "v1alpha1/registries/pack": function () {
    return {
      items: db.collection("repositories").getAll(),
    };
  },

  "v1alpha1/packs/:name/registries/:registryUid": function (
    [_, name, registryUid],
    { cloudType },
  ) {
    return getVersions({ name, registryUid });
  },
};

api.get = function (url, query) {
  const match = Object.keys(PATTERNS).find((key) => {
    const regexp = pathToRegexp(key);
    const results = regexp.exec(url);

    return !!results;
  });

  if (!match) {
    return originalGet(url, query);
  }

  const regexp = pathToRegexp(match);
  const results = regexp.exec(url);
  const response = PATTERNS[match](results, query);

  if (process.env.NODE_ENV === "development") {
    console.log("@@API.GET", { url, response, query });
  }
  return Promise.resolve(response);
};

export default api;
